import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import {
  BausteinAuswahlStatus,
  Produktlinienname,
  TaasRsVmData,
  TaasTarifrisikoschluesselRS,
} from '@ps20/bff-models';
import { delay } from 'rxjs';
import { RsVermieterActions } from '../rs-vermietung-actions.service';
import { IAppState } from '../appState';
import { generateBasicTaasRSVmData } from './transformer/rsVmData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasRsVmData>;

export function* streckenTarifierungVmRS(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    RsVermieterActions.PREIS_REQUESTED,
    RsVermieterActions.SELBSTBETEILIGUNG_CHANGED,
    RsVermieterActions.REMOVE_VERMIETETES_OBJEKT,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS_VERMIETER,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS_VERMIETER,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.RS_VERMIETUNG,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS_VERMIETER,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS_VERMIETER,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_RS_VERMIETER,
    },
    buildTaasRSVmDataForStrecke,
    undefined,
    createHashedRelevantRiskdataVmRS,
  );
  delay(10);
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.RS_VERMIETUNG));
  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.RS_VERMIETUNG));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_RS_VERMIETER,
    safeSaga(streckenTarifierer.handleError, App.RS_VERMIETUNG),
  );
}

export function createHashedRelevantRiskdataVmRS(taasData: TaasRsVmData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  delete relevantData.vermieterBausteine;
  return createHashedTaasData(relevantData);
}

export function buildTaasRSVmDataForStrecke(state: IAppState): TaasRsVmData {
  const rsData: TaasRsVmData = generateBasicTaasRSVmData(state);
  const bausteinAuswahlStatusArray: BausteinAuswahlStatus<TaasTarifrisikoschluesselRS>[] = [];
  bausteinAuswahlStatusArray.push({
    schluessel: TaasTarifrisikoschluesselRS.VERMIETER,
    ausgewaehlt: true,
    isGefahr: false,
    isInklusiv: true,
    anzahlVorschaeden: rsData.anzVorschaeden,
  });
  rsData.salesProducts = {};
  rsData.salesProducts[Produktlinienname.KOMFORT] = bausteinAuswahlStatusArray;
  return rsData;
}
